


export type DynamicBlockType = 'ProjectHeader' | 'CustomerHeader' | 'SupplierHeader';

export const DynamicBlockType = {
    ProjectHeader: 'ProjectHeader' as DynamicBlockType,
    CustomerHeader: 'CustomerHeader' as DynamicBlockType,
    SupplierHeader: 'SupplierHeader' as DynamicBlockType
};

